<template>
  <div class="appCourse" v-html="content">

  </div>
</template>

<script>
import {findUseExplain} from "@/api/picker/index.js";
export default {
    data(){
        return {
            content:''
        }
    },
    methods:{
        getContent(){
            findUseExplain().then(res => {
                // console.log(res);
                let result = res.content.content.replace(/&#x3c;/g,'<').replace(/&#x3e;/g,'>').replace(/&#x22;/g,'"');
                // let result2 = result1.replace(/&#x3e;/g,'>')

                this.content = result
            })
        }
    },
    created(){
        this.getContent();
    }
}
</script>

<style lang="scss" scoped>
    .appCourse {
        height: 100%;
        padding: 10px;
    }
</style>